import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/foto/homepage/ekos-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-71c5fdc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { class: "logoArea" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  id: "logoImg"
}, null, -1))
const _hoisted_4 = { class: "burgerIconArea" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import MainMenu from "@/components/MainMenu.vue";
import {onMounted} from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    mobile: { type: Boolean },
    mobileMenuOpened: { type: Boolean }
  },
  emits: ['change',],
  setup(__props: any) {

const props = __props as {
  mobile: boolean,
  mobileMenuOpened: boolean
}




console.log('mobileMenuOpened: ' + props.mobileMenuOpened)




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        (props.mobile)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change'))),
              class: "icon"
            }, [
              _createElementVNode("div", {
                id: "bar1",
                class: _normalizeClass(["bars", {'bar1-active' : props.mobileMenuOpened}])
              }, null, 2),
              _createElementVNode("div", {
                id: "bar2",
                class: _normalizeClass(["bars", {'bar2-active' : props.mobileMenuOpened}])
              }, null, 2),
              _createElementVNode("div", {
                id: "bar3",
                class: _normalizeClass(["bars", {'bar3-active' : props.mobileMenuOpened}])
              }, null, 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_Transition, { name: "mobile-nav" }, {
            default: _withCtx(() => [
              _createVNode(MainMenu, {
                class: "menuArea",
                mobile: props.mobile,
                mobileMenuOpened: props.mobileMenuOpened,
                onRouterClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change')))
              }, null, 8, ["mobile", "mobileMenuOpened"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!__props.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(MainMenu, {
            class: "menuArea",
            mobile: props.mobile,
            mobileMenuOpened: props.mobileMenuOpened,
            onRouterClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change')))
          }, null, 8, ["mobile", "mobileMenuOpened"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})